import { Props as JoyrideProps, Step } from 'react-joyride'

export enum WtnPages {
  PLAYER_PROFILE = 'PLAYER_PROFILE',
}

export enum PlayerProfileTourSteps {
  PROFILE_OVERVIEW_TAB = 'PROFILE_OVERVIEW_TAB',
  PROFILE_RESULTS_TAB = 'PROFILE_RESULTS_TAB',
  PROFILE_H2H_TAB = 'PROFILE_H2H_TAB',
  PROFILE_WTN_WIDGET = 'PROFILE_WTN_WIDGET',
  PROFILE_ADD_TO_WATCHLIST = 'PROFILE_ADD_TO_WATCHLIST',
  PROFILE_COMPETITIONS_TAB = 'PROFILE_COMPETITIONS_TAB',
  PROFILE_MY_MATCHES_TAB = 'PROFILE_MY_MATCHES_TAB',
}

export type TourStepKey = PlayerProfileTourSteps

export interface TourStep {
  name: TourStepKey
  joyrideStep: Step
  joyrideOptions?: Partial<JoyrideProps>
}

export type GuidedTours = { [key in WtnPages]: TourStepKey[] }

export const GUIDED_TOURS: GuidedTours = {
  PLAYER_PROFILE: Object.values(PlayerProfileTourSteps),
}
